/**
 * Berndorf „Zuletzt angesehen“
 *
 * Der Besuchsverlauf liegt im Browser (localStorage) und besteht NUR aus
 * Handles. Die Kachel wird nicht hier nachgebaut, sondern über die Section
 * Rendering API geholt (`/products/<handle>?section_id=berndorf-product-card`)
 * — dieselbe Kachel wie Listing, Startseite und „Ähnliche Modelle“.
 *
 * Vorher stand an dieser Stelle eine zweite Kachel-Fassung, und sie lief
 * erwartungsgemäß auseinander: ohne `--lifestyle` standen Imagebilder auf der
 * PDP eingepasst statt gefüllt (dort gilt `object-fit: contain`), der Titel
 * kam ohne Serien-Präfix, und der Preis ohne „ab“ — bei mehreren Ausführungen
 * also als Festpreis, der so nicht stimmt. Dieselbe Begründung wie bei der
 * Merkliste, siehe assets/berndorf-wishlist-hook.js.
 */
(function () {
  // v3 speichert nur Handles; v2 hielt ganze Kachel-Daten (Titel, Bild, Preis).
  var STORAGE_KEY = 'bern.recentlyViewed.v3';
  var LEGACY_KEY = 'bern.recentlyViewed.v2';
  var CARD_SECTION = 'berndorf-product-card';
  var MAX_DEFAULT = 8;

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function read() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (raw) {
        var handles = JSON.parse(raw);
        return Array.isArray(handles) ? handles.filter(Boolean) : [];
      }

      // Einmalige Übernahme aus v2, damit ein laufender Besuch seine Liste behält.
      var legacy = window.localStorage.getItem(LEGACY_KEY);
      var items = legacy ? JSON.parse(legacy) : [];
      if (!Array.isArray(items)) return [];

      return items
        .map(function (item) { return item && item.handle; })
        .filter(Boolean);
    } catch (err) {
      // Privater Modus oder gesperrter Speicher: die Sektion bleibt einfach leer.
      return [];
    }
  }

  function write(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (err) {
      /* Speicher nicht verfügbar — bewusst still. */
    }
  }

  function remember(handle, max) {
    var handles = read().filter(function (entry) { return entry !== handle; });
    handles.unshift(handle);
    // +1, weil die gerade besuchte Seite beim Rendern wieder herausfällt.
    handles = handles.slice(0, max + 1);
    write(handles);
    return handles;
  }

  function forget(handle) {
    write(read().filter(function (entry) { return entry !== handle; }));
  }

  /**
   * Holt die gerenderte Kachel. `null` heißt: den Handle gibt es nicht mehr,
   * er ist dann auch schon aus dem Speicher geworfen.
   */
  function fetchCard(handle) {
    return fetch(rootUrl() + 'products/' + encodeURIComponent(handle) + '?section_id=' + CARD_SECTION)
      .then(function (response) {
        if (!response.ok) {
          forget(handle);
          return null;
        }
        return response.text();
      })
      .then(function (html) {
        if (!html) return null;

        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var card = parsed.querySelector('.berndorf-card-wrapper');

        if (!card) {
          forget(handle);
          return null;
        }

        return card;
      })
      .catch(function () {
        // Netzwerkfehler ist kein Grund, den Handle zu vergessen.
        return null;
      });
  }

  function init() {
    var root = document.querySelector('[data-berndorf-recently-viewed]');
    if (!root) return;

    var track = root.querySelector('[data-berndorf-recently-viewed-track]');
    if (!track) return;

    var currentHandle = root.getAttribute('data-current-handle') || '';
    var max = parseInt(root.getAttribute('data-max-items') || MAX_DEFAULT, 10) || MAX_DEFAULT;
    var handles = currentHandle ? remember(currentHandle, max) : read();

    var pending = handles
      .filter(function (handle) { return handle !== currentHandle; })
      .slice(0, max);

    if (!pending.length) {
      root.hidden = true;
      return;
    }

    Promise.all(pending.map(fetchCard)).then(function (cards) {
      track.innerHTML = '';

      cards.forEach(function (card) {
        if (!card) return;
        var slide = document.createElement('li');
        slide.className = 'berndorf-carousel__slide';
        slide.appendChild(card);
        track.appendChild(slide);
      });

      if (!track.children.length) {
        root.hidden = true;
        return;
      }

      root.hidden = false;

      // Das Herz kennt seinen Zustand erst, wenn es angestrichen wurde —
      // die Kachel kommt ja frisch aus dem Netz.
      if (window.BerndorfWishlist && window.BerndorfWishlist.paint) {
        window.BerndorfWishlist.paint(track);
      }

      // Die Pfeile wurden auf der leeren Spur berechnet.
      var carousel = root.querySelector('[data-berndorf-carousel]');
      if (carousel) carousel.dispatchEvent(new CustomEvent('berndorf:carousel-refresh'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Nur neu holen, wenn es wirklich diese Sektion betrifft — sonst stößt jeder
  // Section-Reload im Editor bis zu acht Anfragen an.
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector('[data-berndorf-recently-viewed]')) init();
  });
})();
